import { useStore as getStore } from "../../utils/useStore.js";
import userFactory from "./userFactory.js";

let user = {
  loggedIn: false,
  userData: {},
  isPendingLogin: true,
  jumboFormDetails: {
    formList: [],
    embedPage: {
      PageId: null,
      UserName: null,
      pageExist: false,
      fetched: false,
    },
  },
  contactList: [],
};

const initialState = () => user;

const [UserProvider, useUser, withUser] = getStore(
  userFactory,
  initialState,
  "User"
);

export const userInitState = initialState();

export { useUser, UserProvider, withUser };

export default UserProvider;
